import styled from "styled-components";
import HiddenCheckbox from "./HiddenCheckbox.styled";

const StyledCheckbox = styled.div`
  display: inline-grid;
  place-content: center;
  box-sizing: border-box;
  min-width: ${({ theme }) => theme.sizeCheckbox};
  width: ${({ theme }) => theme.sizeCheckbox};
  height: ${({ theme }) => theme.sizeCheckbox};
  border-radius: ${({ theme }) => theme.borderRadiusCheckbox};
  cursor: pointer;
  border: ${({ theme }) => theme.borderWidthCheckbox} solid
    ${({ theme }) => theme.colors.primary2};
  background-color: ${({ theme }) => theme.colors.baseWhite};

  & img {
    visibility: hidden;
  }

  ${HiddenCheckbox}:checked + & {
    border: 2px solid ${({ theme }) => theme.colors.primary2};
    background-color: ${({ theme }) => theme.colors.baseWhite};
  }

  ${HiddenCheckbox}:checked + & img {
    visibility: visible;
  }
`;

export default StyledCheckbox;
